import * as React from "react";
import { forwardRef } from "react";
const SvgCashFlow = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M18.88 21.3333C18.4136 21.3168 18.0209 21.6791 18 22.1453V28.5333C18.0202 28.9927 18.4071 29.3499 18.8667 29.3333H30.12C30.5864 29.3499 30.9791 28.9876 31 28.5213V22.3333C30.9755 21.7585 30.491 21.3115 29.916 21.3333H18.88Z",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M24.5 24.8413C24.7706 24.8457 24.9869 25.0679 24.984 25.3386C24.981 25.6092 24.76 25.8267 24.4894 25.8253C24.2187 25.8238 24 25.604 24 25.3333C24.0011 25.2018 24.0543 25.076 24.1481 24.9838C24.2419 24.8915 24.3685 24.8403 24.5 24.8413",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M18 25.1373C16.1849 27.7657 13.1942 29.3343 10 29.3333C5.48133 29.3333 1 25.976 1 21.8333C1 17.7427 4.54533 13.2227 7.27333 11.3333C6.48667 9.6 5.85333 8.23333 5.36 7.18C5.07055 6.56055 5.11761 5.83617 5.48476 5.25938C5.8519 4.68258 6.48827 4.33331 7.172 4.33333H14",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M15.7333 14.1947C17.5008 16.1991 18.6319 18.6841 18.9827 21.3333",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.772 23.792C8.35803 24.5617 9.28269 24.9972 10.2493 24.9587C11.768 24.9587 13 24.0347 13 22.896C13 21.7573 11.768 20.8347 10.2493 20.8347C8.73067 20.8347 7.5 19.9107 7.5 18.7707C7.5 17.6307 8.732 16.708 10.2493 16.708C11.2161 16.6688 12.1411 17.1044 12.7267 17.8747",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M10.2493 24.9587V26.3333",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M10.2493 15.3333V16.708",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M31 7.048V2.33333H26.2853",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M31 2.33633L26.6667 6.66566C26.1656 7.16795 25.4288 7.35394 24.7493 7.14966L19.8547 5.84166C19.1878 5.66282 18.4762 5.85343 17.988 6.34166L12.9933 11.3417",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgCashFlow);
export default ForwardRef;
